import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Card from '../../layout/Card';
import ModuleHome from '../../layout/ModuleHome';
import { breadcrumbsPropTypes } from '../../common/resource/proptypes/CommonPropTypes';

const CorporateHome = ({ cards, breadcrumbs }) => (
  <ModuleHome
    title="Ventas Corporativas"
    text="Éste es el módulo de Ventas Corporativas."
    cards={cards}
    breadcrumbs={breadcrumbs}
  />
);

const mapStateToProps = ({ CorporateUnit }) => ({
  cards: CorporateUnit.UnitHome.get('cards'),
  breadcrumbs: CorporateUnit.UnitHome.get('breadcrumbs'),
});

CorporateHome.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  cards: PropTypes.arrayOf(PropTypes.shape(Card.propTypes)).isRequired,
};

export default connect(mapStateToProps)(CorporateHome);
